import { AsyncPipe } from '@angular/common';
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Subject, combineLatest, map } from 'rxjs';

import { PrintOwnPhotosBasketService } from '@ui/print-own-photos/print-own-photos-basket.service';
import { GetAvailablePrintsConfigGQL } from '@ui/products/product-editor/graphql';

@Component({
  selector: 'lib-pick-format-for-own-photos',
  templateUrl: './pick-format-for-own-photos.component.html',
  styleUrls: ['./pick-format-for-own-photos.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true,
  imports: [AsyncPipe],
})
export class PickFormatForOwnPhotosComponent implements OnInit {
  availableSizes$ = combineLatest([
    this.getAvailablePrintsConfigGQL.fetch({}),
    this.ownPhotosBasketService.pricing,
  ]).pipe(
    map(([config, pricing]) => {
      return pricing.list.map((p) => ({
        printFormatId: p.printFormatId,
        label: config.data.availablePrintConfigs.formats.find(
          (f) => f.printFormatId === p.printFormatId,
        )?.label,
      }));
    }),
  );
  picked = new Subject();
  constructor(
    public ownPhotosBasketService: PrintOwnPhotosBasketService,
    private getAvailablePrintsConfigGQL: GetAvailablePrintsConfigGQL,
  ) {}

  ngOnInit(): void {}
}
